import axiosInstance from '../axiosConfig';

export default {
  async getCategoriesTop(payload) {
    const response = await axiosInstance.post('EcomCategorias', payload);
    return response.data;
  },
  async getProductsByCategoryId(payload) {
    const response = await axiosInstance.post(
      'EcomProductosPorCategoria',
      payload
    );
    return response.data;
  },
  async getFeaturedProducts(payload) {
    const response = await axiosInstance.post(
      'EcomProductosDestacados',
      payload
    );
    return response.data;
  },
};
